export const FETCH_MOVIE= "movies/fetchSuccess" 
export const DETAIL_MOVIE= "movies/detailMovies"
export const MOVIE_GENRE= "movies/genre"